import { modalModel } from 'entities/modal';
import { Icons } from 'shared/ui';

export const mainCircleButtons = [
  {
    Icon: Icons.Star,
    modal: modalModel.ModalType.LuxuryLifestyle,
    title: (
      <>
        Luxury Lifestyle
        <br />
        Booking Portal
      </>
    ),
  },
  {
    Icon: Icons.CreditCard,
    modal: modalModel.ModalType.PaymentGateway,
    title: (
      <>
        Universal
        <br />
        Payment Gateway
      </>
    ),
  },
  {
    Icon: Icons.Explorer,
    modal: modalModel.ModalType.Explorer,
    title: `MainNet Explorer`,
  },
  {
    Icon: Icons.SeavProtocol,
    modal: modalModel.ModalType.SEAV,
    title: `SEAV Protocol`,
  },
  {
    Icon: Icons.Staking,
    modal: modalModel.ModalType.Staking,
    title: `Staking Protocol`,
  },
  {
    Icon: Icons.IntellectualProperty,
    modal: modalModel.ModalType.IntellectualProperty,
    title: (
      <>
        Intellectual
        <br />
        Property Blockchain
        <br />
        Co-ownership
      </>
    ),
  },
  {
    Icon: Icons.RealEstate,
    modal: modalModel.ModalType.RealEstate,
    title: (
      <>
        Real Estate
        <br />
        Trading Protocol
      </>
    ),
  },
  {
    Icon: Icons.Commerce,
    modal: modalModel.ModalType.Commerce,
    title: (
      <>
        e-Commerce
        <br />
        Trading Portal
      </>
    ),
  },
] as const;

export const innerCircleButtons = [
  null,
  {
    Icon: Icons.CratSwap,
    modal: modalModel.ModalType.CratSwap,
    title: (
      <>
        CratSwap
        <br />
        V3 (DEX)
      </>
    ),
  },
  {
    Icon: Icons.SmartSwap,
    modal: modalModel.ModalType.SmartSwap,
    title: `Smart Swap`,
  },
  null,
  {
    Icon: Icons.Bridge,
    modal: modalModel.ModalType.Bridge,
    title: (
      <>
        Multi-Chain
        <br />
        Bridge
      </>
    ),
  },
  {
    Icon: Icons.Hammer,
    modal: modalModel.ModalType.Tap2Mine,
    title: (
      <>
        Tap-2-Mine
        <br />
        (Pol Mining)
      </>
    ),
  },
  null,
  null,
] as const;

export const buttonsList = [
  {
    Icon: Icons.Commerce,
    modal: modalModel.ModalType.Commerce,
    title: (
      <>
        e-Commerce
        <br />
        Trading Portal
      </>
    ),
    line: (
      <Icons.Curve
        sx={{
          transform: 'rotateX(180deg)',
        }}
      />
    ),
  },
  {
    Icon: Icons.Star,
    modal: modalModel.ModalType.LuxuryLifestyle,
    title: (
      <>
        Luxury Lifestyle
        <br />
        Booking Portal
      </>
    ),
    line: null,
  },
  {
    Icon: Icons.CratSwap,
    modal: modalModel.ModalType.CratSwap,
    title: (
      <>
        CratSwap
        <br />
        V3 (DEX)
      </>
    ),
    line: (
      <Icons.Curve
        sx={{
          transform: 'rotateZ(180deg) translateX(32px)',
        }}
      />
    ),
  },
  {
    Icon: Icons.SmartSwap,
    modal: modalModel.ModalType.SmartSwap,
    title: `Smart Swap`,
    line: null,
  },
  {
    Icon: Icons.Explorer,
    modal: modalModel.ModalType.Explorer,
    title: (
      <>
        MainNet
        <br />
        Explorer
      </>
    ),
    line: null,
  },
  {
    Icon: Icons.SeavProtocol,
    modal: modalModel.ModalType.SEAV,
    title: `SEAV Protocol`,
    line: null,
  },
  {
    Icon: Icons.Bridge,
    modal: modalModel.ModalType.Bridge,
    title: (
      <>
        Multi-Chain
        <br />
        Bridge
      </>
    ),
    line: null,
  },
  {
    Icon: Icons.Staking,
    modal: modalModel.ModalType.Staking,
    title: `Staking Protocol`,
    line: null,
  },
  {
    Icon: Icons.CreditCard,
    modal: modalModel.ModalType.PaymentGateway,
    title: (
      <>
        Universal
        <br />
        Payment
        <br />
        Gateway
      </>
    ),
    line: null,
  },
  {
    Icon: Icons.Hammer,
    modal: modalModel.ModalType.Tap2Mine,
    title: (
      <>
        Tap-2-Mine
        <br />
        (Pol Mining)
      </>
    ),
    line: (
      <Icons.Curve
        sx={{
          transform: 'translate(12px, 12px)',
        }}
      />
    ),
  },
  {
    Icon: Icons.IntellectualProperty,
    modal: modalModel.ModalType.IntellectualProperty,
    title: (
      <>
        Intellectual
        <br />
        Property
        <br />
        Blockchain
        <br />
        Co-ownership
      </>
    ),
    line: null,
  },
  {
    Icon: Icons.RealEstate,
    modal: modalModel.ModalType.RealEstate,
    title: (
      <>
        Real Estate
        <br />
        Trading
        <br />
        Protocol
      </>
    ),
    line: (
      <Icons.Curve
        sx={{
          transform: 'rotateY(180deg) translateX(20px)',
        }}
      />
    ),
  },
] as const;
